import { cn } from '../../utils/cn';
import { ScrollReveal } from './ScrollReveal';

export function FeatureRow({
  icon: Icon,
  title,
  description,
  art,
  reverse = false,
}) {
  return (
    <ScrollReveal
      x={reverse ? 40 : -40}
      y={0}
      className={cn(
        'flex flex-col items-stretch gap-space-10 mid:flex-row mid:items-center mid:gap-space-16',
        reverse && 'mid:flex-row-reverse',
      )}
    >
      <div className="flex flex-1 flex-col gap-space-4">
        <span className="flex h-11 w-11 items-center justify-center rounded-ds-md bg-sage-100 text-sage-800 dark:bg-sage-900/50 dark:text-sage-200">
          <Icon className="h-6 w-6" aria-hidden />
        </span>
        <h3 className="type-landing-h2">{title}</h3>
        <p className="type-landing-lead max-w-prose">{description}</p>
      </div>
      <div className="flex shrink-0 justify-center mid:basis-[340px] mid:justify-start">
        {art}
      </div>
    </ScrollReveal>
  );
}
